import { stateSigningRequirementsApi } from 'app/services/api';
import _ from 'lodash';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const STATE_SIGNING_REQUIREMENTS_ACTION_TYPE = createNamedActions(
  'stateSigningRequirements',
  {
    GET_STATES: 'GET_STATES',
  },
);

export const getStateSigningRequirements = catchAsyncActionError(() => async dispatch => {
  const { data } = await stateSigningRequirementsApi.getStateSigningRequirements();

  return dispatch({
    type: STATE_SIGNING_REQUIREMENTS_ACTION_TYPE.GET_STATES,
    payload: _.groupBy(data.requirements, 'state.abbreviation'),
  });
});
